import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MultiSelect from "../extra/MultiSelect";
import CountrySelect from "../extra/CountrySelect";
import { Typography } from "@mui/material";

export default function Form({
    title,
    defaultValues = {},
    onSubmit = () => { },
    onChange = () => { },
    back = () => { },
}) {
    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
    } = useForm({
        defaultValues,
        mode: "all",
        shouldFocusError: true,
    });
    console.log("DATA", defaultValues)

    return (
        <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Box className="card-bg shadow rounded" sx={{ p: { xs: 3, md: 4 }, borderRadius: "16px", backdropFilter: "blur(20px)" }}>
                <Typography sx={{ pb: 2, fontWeight: 700, fontSize: 18 }} className="input-label">
                    {defaultValues?.id ? "Edit Worksite" : "Add Worksite"}
                </Typography>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <RFG name="site_name" label="Worksite" control={control}
                                rules={{
                                    required: true, maxLength: 100,
                                }} className="mb-2">
                                <input autoComplete="off" placeholder="Worksite" />
                            </RFG>
                            <Box textAlign="right" sx={{ pt: 2.5 }}>
                                <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                                    Back
                                </Button>
                                <Button
                                    onClick={() => setValue("action", "info")}
                                    className="btn-primary"
                                    type="submit"
                                >
                                    {defaultValues?.id ? "UPDATE" : "ADD"}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </Box>
        </Box>
    );
}
